import styles from './index.module.css'
import { Switch } from '@appkit4/react-components/switch'
import classnames from 'classnames'

export const View = ({ large, label, fontColor, className, ...props }) => {
    const sizeClass = large ? '' : styles.small
    const style = {
        '--switch-label-color': fontColor
    }
    return (
        <Switch className={classnames(styles.default, sizeClass, className)} style={style} {...props}>
            {label}
        </Switch>
    )
}
